import { Card } from "../_shared/card";
import { IconInfo } from "../_shared/icons";
import { navigate } from "../_shared/router";
import { tips } from "../_data/mock";

export function TipsCard() {
  return (
    <Card
      title="Astuces"
      icon={<IconInfo width={22} height={22} />}
      onClick={() => navigate("astuces")}
    >
      <ul className="space-y-2 text-[14px] text-[var(--text-2)]">
        {tips.slice(0, 2).map((t) => (
          <li key={t.id} className="flex items-start gap-2.5">
            <span
              aria-hidden
              className="mt-2 size-1.5 shrink-0 rounded-full bg-[var(--text-3)]"
            />
            <span className="leading-snug">{t.question}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
